import action from '../helpers/rest-client'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewContentOutDto,
  EditContentOutDto,
  DeleteContentOutDto,
  GetOneContentOutDto,
  GetAllContentsOutDto,
} from '../types/content.dto'

export class ErrorContent extends Error { }
const path = '/content'
class Content {
  public new(payload: NewContentOutDto) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idContent, ...rest }: EditContentOutDto) {
    return action
      .Put({
        url: `${path}/${idContent}`,
        body: rest,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAll({ filters, pagination, sort }: GetAllContentsOutDto) {
    const filtersJSON = filters ? `&filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `${path}${paginationString({ pagination, sort })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idContent }: GetOneContentOutDto) {
    return action
      .Get({
        url: `${path}/${idContent}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idContent }: DeleteContentOutDto) {
    return action
      .Del({
        url: `${path}/${idContent}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const content = new Content()
export default content
